// @ts-nocheck
import React, { memo } from 'react';
import Faq from 'src/components/UI/FAQ';
import { SPEED_TEST_FAQ_DATA } from '../constants';

const SpeedTestFaq = () => <Faq titleClasses="paddingBottom-small" items={SPEED_TEST_FAQ_DATA} title="Frequently-Asked Questions" />;

export default memo(SpeedTestFaq);
